import React, { useEffect, useState } from 'react';
import { api } from '../../api';

const POLL_MS = 20000;

// Quiet header light named Cafe Printer Health. Colour (and the tooltip)
// show whether the cafe PC is checking in, stickers are waiting, or a
// job failed. Never blocks sales. Hidden until the agent has checked in
// at least once (or there is already a backlog).
export default function PosCafePrinterPill() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const next = await api.getPosCafePrinters();
        if (!cancelled) setStatus(next);
      } catch {
        if (!cancelled) setStatus((prev) => prev || null);
      }
    };
    load();
    const onFocus = () => { load(); };
    const onVis = () => {
      if (document.visibilityState === 'visible') load();
    };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVis);
    const id = window.setInterval(load, POLL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(id);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, []);

  if (!status || !status.visible || !status.label) return null;

  const tone = status.tone === 'bad' || status.tone === 'warn' || status.tone === 'ok'
    ? status.tone
    : 'ok';

  return (
    <span
      className={`pos-cafe-pill pos-cafe-pill-${tone}`}
      title={status.title || status.label}
      aria-label={status.title || status.label}
      role="status"
    >
      {status.label}
    </span>
  );
}
